import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule} from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatDialogModule,} from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule} from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatProgressBarModule} from '@angular/material/progress-bar';

import { SLoaderComponent } from './component/s-loader/s-loader.component';
import { SDefaultComponent } from './component/s-default/s-default.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    SLoaderComponent,
    SDefaultComponent
  ],
  imports: [
    CommonModule,ReactiveFormsModule,

    MatToolbarModule, MatSidenavModule, MatIconModule,
    MatListModule, MatButtonModule, MatTableModule,
    MatPaginatorModule, MatSortModule, MatFormFieldModule,
    MatInputModule, MatCardModule, MatSelectModule, 
    MatProgressSpinnerModule, MatDialogModule, MatExpansionModule,
    MatSlideToggleModule, MatAutocompleteModule, MatRadioModule, MatChipsModule,
    MatMenuModule, MatDatepickerModule, MatNativeDateModule, MatStepperModule, MatCheckboxModule,MatProgressBarModule
  ],
  exports:[
    MatToolbarModule, MatSidenavModule, MatIconModule,
    MatListModule, MatButtonModule, MatTableModule,
    MatPaginatorModule, MatSortModule, MatFormFieldModule,
    MatInputModule, MatCardModule, MatSelectModule, 
    MatProgressSpinnerModule, MatDialogModule, MatExpansionModule,
    MatSlideToggleModule, MatAutocompleteModule, MatRadioModule, MatChipsModule,
    MatMenuModule, MatDatepickerModule, MatNativeDateModule, MatStepperModule, MatCheckboxModule,MatProgressBarModule,

    SLoaderComponent,
    SDefaultComponent,ReactiveFormsModule
  ],
  
})
export class SharedModule { }
